import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { BaseInfoService } from '@api/base-info.service';
import { ContainersResponseData } from '@shared/model/containers-response.model';
import { IncotermsIdResponseData } from '@shared/model/incoterms-id-response.model';
import { QuotePersistService } from '../quote-persist.service';
import { MatStepper } from '@angular/material/stepper';
import { QuoteExtraService } from '@shared/services/quote-extra-services.service';

@Component({
  selector: 'app-quote-logistics-extra-service',
  templateUrl: './quote-logistics-extra-service.component.html',
  styleUrls: ['./quote-logistics-extra-service.component.scss']
})
export class QuoteLogisticsExtraServiceComponent implements OnInit {
  @ViewChildren(MatCheckbox) private matCheckboxes: QueryList<MatCheckbox>;
  containersOptions: ContainersResponseData[] = [];
  formGroup: FormGroup;
  services=[];
  language = 'fa';
  isDocument = false;
  // customs: CustomsModel[] = [];
  incoterms: IncotermsIdResponseData[];
  
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private baseInfoService: BaseInfoService,
    private quotePersistService: QuotePersistService,
    public stepper: MatStepper,
    // public customsService: CustomsService,
    public quoteExtra: QuoteExtraService
    
    ) {}
  ngOnInit() {
    this.initialForm();
    this.getDocument();
    this.getExtraService();
    this.getIncoterms();
  }
  initialForm(){
    this.formGroup = this.formBuilder.group({
      selectedExtraServices: this.formBuilder.array([]),
      selectedIncotermId: ['', [Validators.required]],
    });
  }
  getExtraService(){
    this.quoteExtra.getServices().subscribe((res: any) => {
      this.services = [];
      this.services = res.data;
      const cache = (this.quotePersistService.getFromLS('logistics-service-details')?.selectedExtraServices) as any[];
      if(this.isDocument){
        for(let i = 0; i < this.services.length; i++){
          if(this.services[i].enTitle === 'Inspection services'){
            this.services.splice(i , 1);
          }
          if(this.services[i]?.enTitle === 'Obtaining a license'){
            this.services.splice(i , 1);
          }
          if(this.services[i]?.enTitle === 'Warehousing'){
            this.services.splice(i , 1);
          }
          if(this.services[i]?.enTitle === 'Payment services'){
            this.services.splice(i , 1);
          }
          if(this.services[i]?.enTitle === 'sourcing and Purchase order'){
            this.services.splice(i , 1);
          }
          if(this.services[i]?.enTitle === 'order registration'){
            this.services.splice(i , 1);
          }
        }
      }
      if(cache){
        for(let i = 0; i < this.services.length; i++){
          this.services[i].checked = false;
          for(let j = 0; j < cache.length; j++){
            if(this.services[i].id === cache[j]){
              this.services[i].checked = true;
            }
          }
        }
      }
    });
  }
  getIncoterms(){
    this.quotePersistService.getIncoterms().subscribe((res) => {
      this.incoterms = res;
    });
  }
  getDocument(){
    this.quoteExtra.getDocument().subscribe((res: any) => {
      this.isDocument = res;
    });
  }
  saveToLS() {
    this.quotePersistService.saveToLS('logistics-service-details', this.formGroup.value);
    this.stepper.next();
  }
  patchFormWithCache() {
    const cache = (this.quotePersistService.getFromLS('logistics-service-details')?.selectedExtraServices) as any[];
    if (!!cache) {
      this.matCheckboxes.forEach(el => {
        if (cache.includes(el.value)) {
          el.checked = true;
        }
      });
      cache.forEach(item => {
        this.onCheckboxChange({checked: true, source: {value: item}});
      });
      const selectedIncotermId = this.quotePersistService.getFromLS('logistics-service-details')?.selectedIncotermId;
      this.formGroup.controls.selectedIncotermId.patchValue(selectedIncotermId);
    }
  }
  onCheckboxChange(e: MatCheckboxChange | any) {
    const services: FormArray = this.formGroup.get('selectedExtraServices') as FormArray;
    if (e.checked) {
      services.push(new FormControl(e.source.value));
    } else {
      let i = 0;
      services.controls.forEach((item: FormControl) => {
        if (item.value === e.source.value) {
          services.removeAt(i);
          return;
        }
        i++;
      });
    }
    this.quotePersistService.saveToLS('logistics-service-details', this.formGroup.value);
  }
  ngAfterViewInit() {
    this.patchFormWithCache();
  }
}